import { render, staticRenderFns } from "./MoleculeSetupLocalStorageCard.vue?vue&type=template&id=49aadd85&scoped=true&"
import script from "./MoleculeSetupLocalStorageCard.vue?vue&type=script&lang=js&"
export * from "./MoleculeSetupLocalStorageCard.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeSetupLocalStorageCard.vue?vue&type=style&index=0&id=49aadd85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aadd85",
  null
  
)

export default component.exports